import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {QueryProvider} from '@shared/queries/query-provider';
import {Configuration} from '@shared/models/configuration';
import {takeUntil} from 'rxjs/operators';
import {Observable, Subject} from 'rxjs';
import {QueryModel} from '@shared/models/query-model';
import {DeleteQueryAction} from '@shared/store/actions/query.actions';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {DeleteSurveyExecutionCommand, UpdateSurveyExecution} from '../../commands/survey.commands';
import {DialogService} from '@shared/services/dialog-service';
import {CommandService} from '@core/services/command.service';
import {getVirtualGridItems} from "@shared/store/selectors/virtual-grid.selector";
import {combineLatest} from "rxjs";
import {TaskManagerService} from "../../../task-manager/services/task-manager.service";
import {GraphqlContentScope} from "@shared/models/graphql-content-scope.model";
import {take} from "rxjs/operators";


@Component({
    standalone: false,
    selector: 'particle-data-survey-execution',
  templateUrl: './data-survey-execution.component.html',
  styleUrls: ['./data-survey-execution.component.scss']
})
export class DataSurveyExecutionComponent implements OnInit, OnDestroy {
  surveyId: string;
  isClose = false;
  sourceKey: string;
  breadcrumbs: BreadcrumbModel[];
  breadcrumbs$: any;
  breadcrumbKey: string;
  ngUnsubscribe = new Subject<void>();
  private survey$: Observable<any>;
  invalidateSubject = new InvalidateSubject();
  survey: any;
  onComponentInit = true;
  private breadcrumbQueryModel: QueryModel;

  constructor(protected store: Store<IQueryState>,
              private router: Router,
              private dialogService: DialogService,
              private commandService: CommandService,
              private taskManagerService: TaskManagerService,
              protected activatedRoute: ActivatedRoute) {
    this.sourceKey = 'DataSurveyExecution';

    this.breadcrumbs = [
      <BreadcrumbModel>{
        id: 'DataSurvey',
        title: 'Data Surveys',
        type: 'DataSurvey',
        relativeUrl: 'data-survey'
      }
    ];
    this.breadcrumbKey = 'BreadcrumbBySurveyId';
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: any) => {
      this.surveyId = params.surveyId;
      const config = Configuration.getSmartGridConfig(this.sourceKey);
     // config.Parameters['SURVEY_ID'] = this.surveyId;
      //this.fetchBreadcumbs();
      //this.fetchSurvey();
    });

    //const queryParams = this.activatedRoute.queryParams.pipe(takeUntil(this.ngUnsubscribe));
    const gridItems = this.store.pipe(select(getVirtualGridItems, this.sourceKey), takeUntil(this.ngUnsubscribe));
    const shouldOpenTask = this.activatedRoute.snapshot.queryParams &&
                           this.activatedRoute.snapshot.queryParams.openTask;
    gridItems.subscribe((result: any) => {
      if (shouldOpenTask && result && result.length > 0) {
          const gridItem = result[0];
          if(this.onComponentInit) {
            this.openSurveyTask(gridItem);
            this.router.navigate(['.'], {relativeTo: this.activatedRoute, queryParams: {}});
            this.onComponentInit = false;
          };
      }
    });

  }

  private fetchBreadcumbs() {
    this.breadcrumbQueryModel = QueryProvider.getQuery(this.breadcrumbKey);
    this.breadcrumbs$ = this.store.pipe(takeUntil(this.ngUnsubscribe), select(getQueryResponse, this.breadcrumbKey));
    this.breadcrumbs$.subscribe(state => {
      if (state) {
        this.breadcrumbs = state.breadcrumb;
      }
    });
    QueryProvider.invokeQuery(this.store, this.breadcrumbKey, {'[ID]': this.surveyId});
  }

  onGridCellValueChange($event) {
    console.log('Data Survey Execution', $event);
    if ($event.action && $event.action.id === 'TaskClosed' && $event.updatedState) {
      this.updateTaskStatus($event);
      return;
    }
    if ($event.action && $event.action.id === 'Delete') {
      this.dialogService.showYesNoDialog('Delete Survey Execution', 'Are you sure you want to delete this survey execution?').pipe(takeUntil(this.ngUnsubscribe)).subscribe(result => {
        if (result && result.action === 'OK') {
          const command = new DeleteSurveyExecutionCommand([$event.item.id]);
          this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
            this.invalidateSubject.invalidate();
          });
        }
      });

      return;
    }
    if ($event.fieldDefinition && $event.fieldDefinition.key == 'title') {
      this.router.navigateByUrl(`data-survey/${$event.item.cells.surveyId.value}/${$event.item.id}`);
    }
    if ($event.fieldDefinition && $event.fieldDefinition.key == 'template') {
      this.router.navigateByUrl(`data-survey/templates/${$event.item.cells.template.value.id}/edit`);
    }

  }

  startSurvey() {
    this.router.navigateByUrl(`data-survey/${this.surveyId}/edit`);
  }
  editSurvey() {
    this.router.navigateByUrl(`data-survey/${this.surveyId}/edit`);
  }

  private fetchSurvey() {
    this.survey$ = this.store.pipe(takeUntil(this.ngUnsubscribe), select(getQueryResponse, 'SurveyById'));
    this.survey$.subscribe(state => {
      if (state) {
        this.survey = state;
      }
    });
    QueryProvider.invokeQuery(this.store, 'SurveyById', {'[SurveyId]': this.surveyId});
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    //this.store.dispatch(new DeleteQueryAction(this.breadcrumbQueryModel, null, null));
  }

  close() {
    this.isClose = true;
  }

  private openSurveyTask(gridItem: any) {
    const taskKey = 'task';
    if(gridItem.cells[taskKey] && gridItem.cells[taskKey].displayText){
      console.log('Open Task');
      const task = gridItem.cells[taskKey].value;

      if (task && task.ticketId && task.boardScope) {
        this.taskManagerService.openTaskByTaskId(task.ticketId, GraphqlContentScope.getScope(task.boardScope)).pipe(take(1)).subscribe(state=>{
          this.onGridCellValueChange({item: gridItem, fieldDefinition: {key: taskKey}, action: {id: 'TaskClosed'}})
        });
      } else{
        this.onGridCellValueChange({item: gridItem, fieldDefinition: {key: taskKey}, action: {id: 'OpenTask'}})
      }
    }
    else{
      console.log('Add Task');
      this.taskManagerService.openTaskSelector().pipe(take(1)).subscribe(selectedTask => {
        console.log(selectedTask);
        this.onGridCellValueChange({item: gridItem, fieldDefinition: {key: taskKey}, action: {id: 'AttachTask'}, payload: selectedTask});
      });
    }
  }
gotToManageTemplate(){
  this.router.navigateByUrl(`data-survey/templates`);
}
  private updateTaskStatus(event: any) {
    const surveyExecutionId = event.item.id;
    const command = new UpdateSurveyExecution(surveyExecutionId);
    this.commandService.executeCommand(command).subscribe(commandState=>{
      if(commandState){
        this.invalidateSubject.invalidate();
      }
    })
  }
}
